module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/toolbar/dist/mdc.toolbar","commonjs2":"@material/toolbar/dist/mdc.toolbar","commonjs":"@material/toolbar/dist/mdc.toolbar","amd":"@material/toolbar/dist/mdc.toolbar","umd":"@material/toolbar/dist/mdc.toolbar"}
// module id = 65
// module chunks = 0